import {  doc, onSnapshot, updateDoc } from 'firebase/firestore';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { db } from '../firebase';


const NoticeBoard = () => {
  const location = useLocation();
  const [noticeDetails,setNoticeDetails] = useState([]);
  const navigate = useNavigate();


  // useEffect(()=>{
  //     const q = query(collection(db, "noticeAll"));
  // onSnapshot(q, (querySnapshot) => {
  //   let noticeArray = [];
  //   querySnapshot.forEach((doc) => {
  //     noticeArray.push({ id: doc.id, ...doc.data() });
  //   });
  //   setNoticeList(noticeArray);
  // });
  // },[])


  useEffect(()=>{
    onSnapshot(doc(db, "noticeAll", location.state.noticeId), (doc) => {
      let array=[]
      array.push({id:doc.id,...doc.data()})
      setNoticeDetails(array);
  });
  },[])

  return (
    <React.Fragment>
      <div className='text-left'>
        <button 
        onClick={()=>navigate(-1)}
        >
          <img src='../assets/back.png'  alt='back' className='h-10 w-h-10'/>
        </button>
      </div>
    <div className='min-h-screen lg:ml-24 lg:mr-24 ml-2 mr-2 md:pt-5'>
              <div className=' '>
              {noticeDetails.map((item,index)=>(
              <div className='w-full border'key={index}>
             <div className="text-center" >
              <div className='hidden'>{++index}</div>
             <div className="grid grid-cols-3 bg-[#033f63] w-full py-2 text-center font-bold text-white text-xl">
            <div className='col-span-2'>{item.noticeTitle}</div>
            <div> {item.noticeDate.split('-').reverse().join('-')}
                  </div>
           </div>
              <div className=" w-64 mx-auto py-2 underline underline-offset-8">
              <span className='text-center font-bold text-black  mt-5 text-xl '>NOTICE</span>
            </div>
           </div>
           <div className='mt-8 ml-8 mr-8 text-left'>{item.notice}</div> 
           <div className='mt-8 mb-8 text-left ml-8'>
                <div className='mt-2 '>Regards,</div>
                <div className='mt-2 uppercase'>s s yadav</div>
                <div className='mt-2 uppercase'>Principal</div>
             </div>
           </div>
          ))}
           </div>  
    
    </div>
    </React.Fragment>
  )
}

export default NoticeBoard